module.exports = __webpack_public_path__ + "img/logout_btn.8508060a.svg";